import {Controller} from "stimulus"
import $ from 'jquery';

import popper from '@popperjs/core'


export default class extends Controller {

    connect() {
        this.place = this.element;
        if (this.element.dataset.target !== undefined){
            this.dataset_target = $(`#${this.element.dataset.target}`);
            const placePicker = document.getElementById(this.element.id);
            placePicker.addEventListener('gmpx-placechange', () => {
                const place = placePicker.value;
                this.dataset_target.val(place.formattedAddress)
            });
        }else{
            toastr.error('No existe el elemento target')
        }
    }


}